package com.mps.asc_app.ui.screens

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.mps.asc_app.ui.theme.AscGoldLight
import com.mps.asc_app.ui.theme.AscLine
import com.mps.asc_app.ui.theme.AscNavy
import com.mps.asc_app.ui.theme.AscNavyInk

/** Initialen für den Kreis im Profil: "anna.becker@…" -> "AB", "max@…" -> "M". */
internal fun initialsFor(email: String?): String {
    val local = email?.substringBefore('@').orEmpty()
    val parts = local.split('.', '_', '-').filter { it.isNotBlank() }
    return parts.take(2).joinToString("") { it.first().uppercase() }.ifEmpty { "?" }
}

/**
 * Profil (Redesign Stufe 2, Grundgerüst): Konto und Abmelden. Spielerprofil, Vertrauensgruppen und
 * "Was ist neu" kommen mit dem Mehrspieler-Branch dazu.
 */
@Composable
fun ProfileScreen(
    email: String?,
    roleLabel: String,
    onLogout: () -> Unit,
    contentPadding: PaddingValues = PaddingValues(),
) {
    Column(
        modifier = Modifier
            .fillMaxSize()
            .padding(contentPadding)
            .verticalScroll(rememberScrollState()),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .background(AscNavy)
                .padding(horizontal = 20.dp, vertical = 24.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(14.dp),
        ) {
            Box(
                modifier = Modifier.size(64.dp).background(AscGoldLight, CircleShape),
                contentAlignment = Alignment.Center,
            ) {
                Text(initialsFor(email), style = MaterialTheme.typography.titleLarge, color = AscNavyInk, fontWeight = FontWeight.Bold)
            }
            Column {
                Text(email ?: "Angemeldet", style = MaterialTheme.typography.titleMedium, color = MaterialTheme.colorScheme.onPrimary)
                Text(roleLabel, style = MaterialTheme.typography.bodyMedium, color = AscGoldLight)
            }
        }

        Column(
            modifier = Modifier.fillMaxWidth().widthIn(max = 720.dp).padding(16.dp),
            verticalArrangement = Arrangement.spacedBy(12.dp),
        ) {
            Surface(
                shape = RoundedCornerShape(16.dp),
                color = MaterialTheme.colorScheme.surface,
                border = BorderStroke(1.dp, AscLine),
                modifier = Modifier.fillMaxWidth(),
            ) {
                Text(
                    text = "Abmelden",
                    color = MaterialTheme.colorScheme.error,
                    style = MaterialTheme.typography.bodyLarge,
                    fontWeight = FontWeight.SemiBold,
                    modifier = Modifier
                        .fillMaxWidth()
                        .clickable(role = Role.Button, onClick = onLogout)
                        .heightIn(min = 52.dp)
                        .padding(horizontal = 16.dp, vertical = 14.dp),
                )
            }
        }
    }
}
